import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { ProductLogRow } from './components/ProductLogRow';
import type { ProductLogDto } from './types/ProductLogDto';

export function ProductLogs() {
	const { organisation } = useParams();

	const filter = useFilter();
	const pagination = usePagination();

	const productsQuery = queryWithFilterAndPages<ProductLogDto[]>(
		`${organisation}/product-logs/all`,
		filter.value,
		pagination.value,
	);

	const productsCountQuery = queryWithFilter<number>(
		`${organisation}/product-logs/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Product Logs'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={productsCountQuery.data?.value}
				isRowsLoading={productsQuery.isLoading}
				isPaginationLoading={productsCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator'} />
						</Table.Th>
						<Table.Th>
							<Title label={'SKUID'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Description'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Till'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Price'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Case Qty.'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Stock Qty.'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Stock Changed'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Log Type'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{productsQuery.data?.value.map((p) => (
						<ProductLogRow originalProduct={p} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
